'use strict';

var Driver = global.WebSocket || global.MozWebSocket;
if (Driver) {
	module.exports = function WebSocketBrowserDriver(url) {
		return new Driver(url);
	};
} else {
	module.exports = undefined;
}



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/transport/browser/websocket.js
// module id = 378
// module chunks = 1